// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3dE72","list":"PatternAutocomplete_list__NwSWs"};